<div class="pag-container">

  <app-campaign-3-breadcrumb #breadcrumbComponent [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink="/campaign-list-3">
  </app-campaign-3-breadcrumb>


  <div class="ui-g-12">
    <app-campaign-3-kontable #table title="Coupon" [columns]="[
      {field: 'coupon_code', title: 'campaign.couponCode'},
      {field: 'cust_name', title: 'campaign.customerName'},
      {field: 'cust_surname', title: 'campaign.customerSurname'},
      {field: 'emission_date_start', title: 'campaign.emissionStartDate', type: 'date', filterType: dateFilter},
      {field: 'emission_date_end', title: 'campaign.emissionEndDate', type: 'date', filterType: dateFilter},
      {field: 'fruition_date_start', title: 'campaign.fruitionStartDate', type: 'date', filterType: dateFilter},
      {field: 'fruition_date_end', title: 'campaign.fruitionEndDate', type: 'date', filterType: dateFilter},
      'card_no'
    ]" [titles]="['loyalty.card_no']" [service]="couponService" [paginationType]="paginationType"
      [showRecoverButton]="false" [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false"
      [showDetailsButton]="false" [showEditButton]="false"
      [filterBySingleColumn]="false" (onRemove)="deleteCoupon($event)" [additionalRowCommands]="actions">
    </app-campaign-3-kontable>

    <ng-template #actions let-row>
      <div class="detail-btn-container">
        <button class="btn-details" (click)="onEditCoupon(row)">
          <i class="pi pi-pencil"></i>
        </button>
        <!-- Apertura menù a tendna -->
        <button  pTooltip="{{ 'common.actions' | translate }}" class="btn-details" (click)="toggleMenu(row.id)">
          <i class="pi pi-ellipsis-h icon-size"></i>
        </button>
      </div>

      <!-- Contenuto menù a tendina -->
      <!-- TODO aggiungere le traduzioni -->
      <div class="dropdown-menu" *ngIf="showMenu && row.id == currentOpenedRow">

        <button (click)="onEditCoupon(row)"  class="dropdown-item-creation" [ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'common.edit' |
          translate }}
        </button>
        <!-- Funzionalità legata alla vecchia pagina -->
      <!--   <button (click)="viewCouponHistory(row)"  class="dropdown-item-creation"[ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'common.viewCoupon' |
          translate }}
        </button> -->
        
        <button (click)="printCoupon(row, 'P')"  class="dropdown-item-creation" [ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'campaign.printCoupon' |
          translate }}
        </button>

        <button (click)="reserveCoupon(row)"    class="dropdown-item-creation" [ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'campaign.reserveCoupon' |
          translate }}
        </button>

        <button (click)="useCoupon(row)"   class="dropdown-item-creation"[ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'campaign.useCoupon' |
          translate }}
        </button>
        
        <button (click)="undoReserveCoupon(row)"  class="dropdown-item-creation"[ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'campaign.undoReserveCoupon' |
          translate }}
        </button>
        
        <button (click)="undoUseCoupon(row)"  class="dropdown-item-creation" [ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'campaign.undoUseCoupon' |
          translate }}
        </button>

        <button (click)="printCoupon(row, 'UP')"  class="dropdown-item-creation"[ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'campaign.printCoupon' |
          translate }}
        </button>



<!-- 
        <p-button pTooltip="{{ 'campaign.couponHistory' | translate }}" icon="fa fas fa-eye" styleClass="ui-button-info" (onClick)="viewCouponHistory(row)"></p-button>
        <p-button pTooltip="{{ 'campaign.printCoupon' | translate }}" icon="fa fas fa-print" styleClass="ui-button-info" (onClick)="printCoupon(row, 'P')"></p-button>
        <p-button pTooltip="{{ 'campaign.reserveCoupon' | translate }}" icon="fa fas fa-pencil" styleClass="ui-button-info" (onClick)="reserveCoupon(row)"></p-button>
        <p-button pTooltip="{{ 'campaign.useCoupon' | translate }}" icon="fa fas fa-download" styleClass="ui-button-info" (onClick)="useCoupon(row)"></p-button>
        <p-button pTooltip="{{ 'campaign.undoReserveCoupon' | translate }}" icon="fa fas fa-mail-reply" styleClass="ui-button-info" (onClick)="undoReserveCoupon(row)"></p-button>
        <p-button pTooltip="{{ 'campaign.undoUseCoupon' | translate }}" icon="fa fas fa-mail-reply-all" styleClass="ui-button-info" (onClick)="undoUseCoupon(row)"></p-button>
        <p-button pTooltip="{{ 'common.cancel' | translate }} {{ 'campaign.printCoupon' | translate }}" icon="fa fas fa-ban" styleClass="ui-button-info" (onClick)="printCoupon(row, 'UP')"></p-button>
 -->

      </div>

    </ng-template>
  </div>

  <div class="ui-g-12 text-right" style="float:unset;">
    <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" (click)="goBack()"
      label="{{ 'common.back' | translate }}"></button>
  </div>

  <p-dialog *ngIf="showEditForm" [(visible)]="showEditForm" [modal]="true"
    header="{{'campaign.editCoupon' | translate}}" [width]="700" [draggable]="false" [resizable]="false">
    <app-coupon-form-3 [coupon]="couponToEdit" (couponSaved)="saveCoupon($event)">
    </app-coupon-form-3>
  </p-dialog>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/coupon-list-3/coupon-list-3.component.html